import React from "react"
import { IconSeeker } from "@ui-seeker/core"


export default function AppCheckCrossIcon({ condition, checkIcon, crossIcon, checkProps, crossProps }) {
    return condition
        ? <IconSeeker icon="check" {...checkIcon} sx={{ color: "success.main", ...checkProps }} />
        : <IconSeeker icon="xmark" {...crossIcon} sx={{ color: "error.main", ...crossProps }} />
}